import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';
import GameDetailsContentCardRow from '../Row';

export default function GameDetailsContentCardSkeleton() {
  return (
    <div className={styles.card}>
      <div className={styles.card__header}>
        <div className={skeleton.icon} />
        <div className={skeleton.title} />
      </div>
      <div className={styles.card__content}>
        <GameDetailsContentCardRow isLoading title="" />
        <GameDetailsContentCardRow isLoading title="" />
        <GameDetailsContentCardRow isLoading title="" />
      </div>
    </div>
  );
}
